import React from "react";
import { connect } from "react-redux";
import moment from "moment";

moment().locale('es');

const mapState = (state) => {
	return {
		pagoPorKilometro: state.polizas.pagoPorKilometro,
        detalleAutorizador: state.registroDbk.detalleAutorizador,
        styleExitoso:state.registroDbk.styleExitoso
	};
};

const mapDispatch = (dispatch) => {
	return {
		setDetalleAutorizador: (data) => {

			dispatch({
				type: 'SET_DETAIL_DBK',
				detalleAutorizador: data
			});

        },
        mostrarMensajePolizaAgregada: (sTitulo, sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": sTitulo, "mensaje": sMensaje });
		}
	};
};

class DetalleAutorizadorDbk extends React.Component{
		state={
            bloqueado:false,
            detalleAutorizador:{},
            styleExitoso:false
		};
    
    componentWillReceiveProps(nextProps){
        debugger;
        if(nextProps.detalleAutorizador != null){
            this.setState({detalleAutorizador:nextProps.detalleAutorizador});
         console.log(nextProps.detalleAutorizador);
        }else{
          console.log("no llegan los datos");
        }
        if(nextProps.styleExitoso!= null){
            this.setState({styleExitoso:nextProps.styleExitoso});
         console.log(nextProps.styleExitoso);
        }else{
          console.log("no llegan los datos");
        }
      }
      componentDidMount = () => {
        this.setState({detalleAutorizador:this.props.detalleAutorizador});
        console.log("entra:"+JSON.stringify(this.state.detalleAutorizador));
	}

	render(){
		return(
			<div className="popup-km">
				<div className="mt-34">
					<div className="modal-container">
						<h5 className="pd-lr-30">Detalle Kilometraje
							<button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"><img src={ require("../../img/x.svg") } alt="" /></button>
						</h5>
						<hr className="mt-34" />
						<div className="row"> 
							<div className="col-xs-12 col-md-10 col-md-offset-1">
								<div className="row">
									<table className="table table-striped table-center mt-34 tabla-recibos hidden-xs">
										<thead>
										<tr>
											<th className="text-center"><span className="hide-mobile">Kilometraje Inicial</span></th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td className="text-center">{this.props.detalleAutorizador.km}</td>
										</tr>
										</tbody>
									</table>
									<table className="table table-striped table-center mt-34 tabla-recibos tabla-images hidden-xs">
										<thead>
											<tr>
												<th className="text-center">Fotografías</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="">
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.supIzq == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.supIzq}><img className="img-responsive center-block" src={this.props.detalleAutorizador.supIzq} /></a>}</div>
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.supDer == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.supDer}><img className="img-responsive center-block" src={this.props.detalleAutorizador.supDer} /></a>}</div>
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.infIzq == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.infIzq}><img className="img-responsive center-block" src={this.props.detalleAutorizador.infIzq} /></a>}</div>
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.infDer == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.infDer}><img className="img-responsive center-block" src={this.props.detalleAutorizador.infDer} /></a>}</div>
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.vin == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.vin}><img className="img-responsive center-block" src={this.props.detalleAutorizador.vin} /></a>}</div>
												<div className="col-md-2 col-sm-3">{this.props.detalleAutorizador.ini == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.ini}><img className="img-responsive center-block" src={this.props.detalleAutorizador.ini} /></a>}</div>
												</td>
											</tr>
										</tbody>
									</table>
                                    <table className="table table-striped table-center mt-34 tabla-recibos hidden-xs">
										<tbody>
                                            <tr>
                                                {this.state.detalleAutorizador.styleCompleto ? <td><button ref="boton" name="exitoso" data-toggle="modal" data-target="#modal-confirmacionDBK" className="orange-rectangle" style={{"margin":"0px auto 0px auto","width":"150px","padding":"4px 4px"}}> Registro completo</button></td>:null}
                                                {this.state.detalleAutorizador.styleNuevo ? <td><button ref="boton" name="reintento" data-toggle="modal" data-target="#modal-confirmacionRN"  className="orange-rectangle" style={{"margin":"0px auto 0px auto","width":"150px","padding":"4px 4px"}}> Registrar nuevamente</button></td>:null}
                                                {this.state.detalleAutorizador.styleCancelado ? <td><button ref="boton" name="rechazado" data-toggle="modal" data-target="#modal-confirmacionRechazo" className="orange-rectangle" style={{"margin":"0px auto 0px auto","width":"150px","padding":"4px 4px"}}> Registro cancelado</button></td>:null}
                                            </tr>
										</tbody>
									</table>
								</div>
							</div>
							<div className="hidden-sm hidden-md hidden-lg ">
								<p className="text-center" style={{borderBottomColor:'1px solid rgb(255, 111, 32)', paddingTop: '4%', color: 'rgb(24, 61, 123)', fontWeight: 'bold'}}>Captura Inicial</p>
								<div className="row">
									<div className="col-xs-12 col-xs-offset2">
										<p className="text-center">
											{this.props.detalleAutorizador.km == null ? '' : this.props.detalleAutorizador.km.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</p>
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.supIzq == null ? '' : <a target="_blank" href={this.props.detalleAutorizador.supIzq}><img className="img-responsive center-block" src={this.props.detalleAutorizador.supIzq} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.supDer == null ? '' :<a target="_blank" href={this.props.detalleAutorizador.supDer}><img className="img-responsive center-block" src={this.props.detalleAutorizador.supDer} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.infIzq== null ? '' :<a target="_blank" href={this.props.detalleAutorizador.infIzq}><img className="img-responsive center-block" src={this.props.detalleAutorizador.infIzq} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.infDer == null ? '' :<a target="_blank" href={this.props.detalleAutorizador.infDer}><img className="img-responsive center-block" src={this.props.detalleAutorizador.infDer} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.vin == null ? '' :<a target="_blank" href={this.props.detalleAutorizador.vin}><img className="img-responsive center-block" src={this.props.detalleAutorizador.vin} /></a>}
									</div>
									<div className="col-xs-12 col-xs-offset2">
										{this.props.detalleAutorizador.ini == null ? '' :<a target="_blank" href={this.props.detalleAutorizador.ini}><img className="img-responsive center-block" src={this.props.detalleAutorizador.ini} /></a>}
									</div>
								</div>
							</div>
						</div>
                    </div>
				</div>
			</div>
		);

    }
}


export default connect(mapState,mapDispatch)(DetalleAutorizadorDbk);


// WEBPACK FOOTER //
// ./src/autorizadorDBK/km0/detalleAutorizadorDbk.cmpt.js